import Spinner from "components/Spinner";

export const FullWidthLoadingSpinner = () => {
    return (<div className="flex justify-center items-center w-full">
      <Spinner className="w-5 h-5 animate-spin m-10 text-neutral-500 dark:text-neutral-500" />
    </div>);
}
